/**
 * Categorised reprint/refund reason options used by the Reprint and Refund
 * drawers. Each entry carries a `group` so Mantine's `Select` renders them
 * under section headings that match the Figma "Menu – Reprint & Refund
 * Reasons" design.
 */
export const REPRINT_REASONS = [
  { value: "Color Output Variance", label: "Color Output Variance", group: "Print" },
  { value: "Duplicate Pages", label: "Duplicate Pages", group: "Print" },
  { value: "Ghosting", label: "Ghosting", group: "Print" },
  { value: "Incorrect Substrate", label: "Incorrect Substrate", group: "Print" },
  { value: "Misregistration (front to back)", label: "Misregistration (front to back)", group: "Print" },
  { value: "Misregistration (color to color)", label: "Misregistration (color to color)", group: "Print" },
  { value: "Missing Pages", label: "Missing Pages", group: "Print" },
  { value: "Spots, Voids, Banding, Smears", label: "Spots, Voids, Banding, Smears", group: "Print" },
  { value: "Wrinkled/Creased Pages", label: "Wrinkled/Creased Pages", group: "Print" },

  { value: "Bad Saddle Stitching", label: "Bad Saddle Stitching", group: "Binding" },
  { value: "Broken Spine", label: "Broken Spine", group: "Binding" },
  { value: "Crooked Cover", label: "Crooked Cover", group: "Binding" },
  { value: "Endsheets (alignment)", label: "Endsheets (alignment)", group: "Binding" },
  { value: "Endsheets (bubble/wrinkle)", label: "Endsheets (bubble/wrinkle)", group: "Binding" },
  { value: "Endsheets (wrong endsheets)", label: "Endsheets (wrong endsheets)", group: "Binding" },
  { value: "Excessive Glue/Glue Residue", label: "Excessive Glue/Glue Residue", group: "Binding" },
  { value: "Incorrect/Damaged Wire-O", label: "Incorrect/Damaged Wire-O", group: "Binding" },
  { value: "Ink Cracking in Gutter (Layflat)", label: "Ink Cracking in Gutter (Layflat)", group: "Binding" },
  { value: "Pages Falling Out", label: "Pages Falling Out", group: "Binding" },
  { value: "Pages not Glued Correctly (Layflat)", label: "Pages not Glued Correctly (Layflat)", group: "Binding" },
  { value: "PUR Glue Spikes", label: "PUR Glue Spikes", group: "Binding" },
  {
    value: "Slipsheet or job ticket bound in book block",
    label: "Slipsheet or job ticket bound in book block",
    group: "Binding",
  },
  { value: "Wavy Pages", label: "Wavy Pages", group: "Binding" },
  { value: "Wrong Linen Type", label: "Wrong Linen Type", group: "Binding" },
  { value: "Wrong Orientation", label: "Wrong Orientation", group: "Binding" },
  { value: "Wrong Page Order", label: "Wrong Page Order", group: "Binding" },
  { value: "Wrong Spine Size", label: "Wrong Spine Size", group: "Binding" },
  { value: "Binding - Missing Pages", label: "Missing Pages", group: "Binding" },

  { value: "Incorrect Score Line", label: "Incorrect Score Line", group: "Finishing" },
  { value: "Incorrect Foil Used", label: "Incorrect Foil Used", group: "Finishing" },
  {
    value: "Lamination (bubbles/articles under the Lamination)",
    label: "Lamination (bubbles/articles under the Lamination)",
    group: "Finishing",
  },
  { value: "Lamination (delamination/peeling)", label: "Lamination (delamination/peeling)", group: "Finishing" },
  { value: "Lamination (wrong lamination)", label: "Lamination (wrong lamination)", group: "Finishing" },
  { value: "Physical Damage", label: "Physical Damage", group: "Finishing" },
  { value: "Trimming (image off-center)", label: "Trimming (image off-center)", group: "Finishing" },
  { value: "Trimming (incorrect die)", label: "Trimming (incorrect die)", group: "Finishing" },
  { value: "Trimming (rough/unclean trim)", label: "Trimming (rough/unclean trim)", group: "Finishing" },
  { value: "Trimming (wrong trim dimensions)", label: "Trimming (wrong trim dimensions)", group: "Finishing" },
  { value: "UV (inconsistent UV)", label: "UV (inconsistent UV)", group: "Finishing" },
  { value: "UV (missing)", label: "UV (missing)", group: "Finishing" },

  { value: "Damage due to improper packaging", label: "Damage due to improper packaging", group: "Shipping" },
  { value: "Incorrect Quantity", label: "Incorrect Quantity", group: "Shipping" },
  { value: "Package Not Scanned", label: "Package Not Scanned", group: "Shipping" },

  { value: "Complete Wrong Order", label: "Complete Wrong Order", group: "Not Mine" },
  { value: "Correct Cover / Wrong Text", label: "Correct Cover / Wrong Text", group: "Not Mine" },
  { value: "Wrong Cover / Correct Text", label: "Wrong Cover / Correct Text", group: "Not Mine" },
  {
    value: "Partial Wrong Order (additional cards/pages added)",
    label: "Partial Wrong Order (additional cards/pages added)",
    group: "Not Mine",
  },
  {
    value: "Received Additional Items (their items + another customer's items)",
    label: "Received Additional Items (their items + another customer's items)",
    group: "Not Mine",
  },

  { value: "Damaged in Transit", label: "Damaged in Transit", group: "Courier" },
  { value: "Lost in Transit", label: "Lost in Transit", group: "Courier" },
  { value: "Returned to Sender", label: "Returned to Sender", group: "Courier" },

  { value: "No Credit", label: "No Credit", group: "Customer" },
];
